
import * as actions from 'actions';
import emojisMaker from 'reducersMakers/emojisMaker';

export default emojisMaker({
  showType: actions.MAIL_EMOJIS_SHOW,
  closeType: actions.MAIL_EMOJIS_HIDE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/emojis/teamMessage/reducer.js
 **/